// Site Configuration - Easy to update

export const LOGO_URL = '/petechtor-logo.webp';

// Guardian Feed Photos - Change these URLs anytime
export const GUARDIAN_FEED_PHOTOS = [
  {
    image: 'https://images.unsplash.com/photo-1769117140058-1e175904bad2',
    alt: 'Senior loyal dog looking up attentively at their guardian',
    caption: "Real sidekick moments we're here to protect"
  },
  {
    image: 'https://images.unsplash.com/photo-1769694810455-887f40b1c3e6',
    alt: 'White fluffy dog standing guard protectively',
    caption: "Real sidekick moments we're here to protect"
  },
  {
    image: 'https://images.unsplash.com/photo-1613304750786-eb724b133f26',
    alt: 'Cat bond with owner showing trust and protection',
    caption: "Real sidekick moments we're here to protect"
  },
  {
    image: 'https://images.unsplash.com/photo-1522858547137-f1dcec554f55',
    alt: 'Blue budgie showing trust and companionship with owner',
    caption: "Real sidekick moments we're here to protect"
  },
  {
    image: 'https://images.unsplash.com/photo-1759289615419-509c6da47a23',
    alt: 'Alert brown dog in protective stance watching over home',
    caption: "Real sidekick moments we're here to protect"
  },
  {
    image: 'https://images.unsplash.com/photo-1763719896164-baf765c6e94b',
    alt: 'Peaceful cat showing comfort and trust',
    caption: "Real sidekick moments we're here to protect"
  }
];

// Add more photos here:
// {
//   image: 'YOUR_IMAGE_URL_HERE',
//   alt: 'Description for accessibility',
//   caption: 'Caption text to display'
// }
